<template>
  <template v-if="file != null">
    <template v-if="file.file_id != null">
      <Suspense>
        <jr-file-view :fileId="file.file_id" :tagView="true" />
      </Suspense>
    </template>
    <template v-else>
      <span class="text-xs file-delete">ファイル削除-{{ file.type_name }}</span>
    </template>
  </template>
  <template v-else>
    <template v-if="isTooltip">
      <el-tooltip
        effect="dark"
        :content="messageBody"
        placement="top"
        popper-class="message-history-tooltip-width pre-wrap-tooltip"
      >
        <router-link v-if="to != null" :to="to">
          <span class="text-xs body">{{ displayBody }}</span>
        </router-link>
        <span v-else class="text-xs body">{{ displayBody }}</span>
      </el-tooltip>
    </template>
    <template v-else>
      <router-link v-if="to != null" :to="to">
        <span class="text-xs body">{{ displayBody }}</span>
      </router-link>
      <span v-else class="text-xs body">{{ displayBody }}</span>
    </template>
  </template>
</template>

<script lang="ts">
import MessageTypeLogic from '@/services/messageTypeLogic'
import { defineComponent, computed, ref, watch } from 'vue'
import { RouteLocationRaw } from 'vue-router'
import JrFileView from '@/components/jr-parts/JrFileView.vue'

/**
 * ファイル情報
 */
interface File {
  file_id: number | null
  type_name: string
}

/**
 * メッセージ履歴 内容表示コンポーネント
 */
export default defineComponent({
  name: 'MessageHistoryBody',
  components: {
    JrFileView,
  },
  props: {
    // 本文
    body: {
      type: String,
      required: true,
    },
    // 申請基本ID
    requestHeaderId: {
      type: Number,
      required: true,
    },
    // メッセージ種別
    messageType: {
      type: Number,
      required: true,
    },
    // メッセージID
    messageId: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const logic = computed(() => {
      return new MessageTypeLogic(props.messageType, props.requestHeaderId)
    })
    const displayBody = ref<string>('')
    const messageBody = ref<string>('')
    const to = ref<RouteLocationRaw | null>(null)
    const file = ref<File | null>(null)
    const isTooltip = ref<boolean>(true)

    watch(
      () => [logic, props.messageId],
      async () => {
        // 初期化
        displayBody.value = ''
        messageBody.value = ''
        to.value = null
        file.value = null

        if (logic.value.hasFile()) {
          // ファイルが関連する種別なら情報を格納
          const file_id = await logic.value.getFile(props.messageId)
          file.value = {
            file_id: file_id,
            type_name: logic.value.getTypeName(),
          }
        }
        // ロジック変更時、表示文字列を変える。固定文字があればそれを採用する
        displayBody.value = (await logic.value.getFixedHistoryBody(props.messageId)) ?? logic.value.getTypeName()
        messageBody.value = props.body
        isTooltip.value = logic.value.isDisplayTooltip()
        // リンク先の取得
        if (logic.value.isDisplayHistoryLink()) {
          //近接協議の結果表示の場合のリンク先を取得
          if (logic.value.isProximityResult()) {
            to.value = logic.value.getProximityResultLocation(props.messageId)
            return
          }
          //境界立会の結果表示の場合リンク先を取得
          if (logic.value.isBoundaryResult()) {
            to.value = logic.value.getBoundaryResultLocation(props.messageId)
            return
          }
          to.value = logic.value.getJrReceiveLocation(props.messageId)
        }
      },
      { immediate: true, deep: true }
    )

    return {
      displayBody,
      messageBody,
      to,
      file,
      isTooltip,
    }
  },
})
</script>
